import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { ListingMenuButtonFull } from "src/components/Shared/ListingMenuButton";
import intl from "react-intl-universal";
import { AUTH_TITLE } from "src/utils";

const LoginRegiButton = (props: { handleAuthClick: (title: AUTH_TITLE) => void }) => {
    const { handleAuthClick } = props;

    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 576);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <StyledLoginRegisterButton
            onClick={() => handleAuthClick(AUTH_TITLE.LOGIN_OR_REGISTER)}
        >
            {isMobile ? intl.get("navbar.login") : `${intl.get("navbar.login")}/${intl.get("navbar.register")}`}
        </StyledLoginRegisterButton>
    );
};

const StyledLoginRegisterButton = styled(ListingMenuButtonFull)`
    && {
        background: ${({ theme }) => theme.color.manorleadGold};
        color: ${({ theme }) => theme.color.blackPrimary};
        width: auto;
        min-width: max-content;
        font-family: ${({ theme }) => theme.fontFamily.homeBody};
        font-weight: 500;
        height: 40px;
        ${({ theme }) => theme.styleGroup.body}

        padding: 10px 20px;
        font-size: 16px;
        line-height: 1;
        margin-right: 0;
        border: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;

        &:hover,
        &:focus,
        &:active {
            background: ${({ theme }) => theme.color.manorleadGold};
            color: ${({ theme }) => theme.color.blackPrimary};
            filter: brightness(95%);
        }
    }

    @media (max-width: 576px) {
        && {
            padding: 0 16px;
            font-size: 14px;
            height: 32px;
            border-radius: 16px;
            position: static;
        }
    }
`;

export default LoginRegiButton;
